import ProcessHub from './ProcessHub'

export default function useProcesses({ userId, filter, onChange, onStart, onProgress, onCompleted, onCancelled }) {
  ProcessHub.init(userId)

  const listWithFilter = () => {
    if (!onChange) return
    if (filter && Array.isArray(filter.type)) {
      const lists = filter.type.map(t => ProcessHub.list({ ...filter, type: t }))
      const merged = [].concat(...lists)
      onChange(merged)
    } else {
      onChange(ProcessHub.list(filter))
    }
  }

  // сразу отдать состояние
  listWithFilter()

  const offs = []
  if (onStart)     offs.push(ProcessHub.on('start',     p => { if (match(p, filter)) onStart(p) }))
  if (onProgress)  offs.push(ProcessHub.on('progress',  p => { if (match(p, filter)) onProgress(p) }))
  if (onCompleted) offs.push(ProcessHub.on('completed', p => { if (match(p, filter)) onCompleted(p) }))
  if (onCancelled) offs.push(ProcessHub.on('cancelled', p => { if (match(p, filter)) onCancelled(p) }))

  if (onChange) {
    offs.push(ProcessHub.on('change', listWithFilter))
  }

  return () => offs.forEach(off => off())
}

function match(p, filter = {}) {
  if (!filter) return true
  if (filter.type) {
    if (Array.isArray(filter.type)) {
      if (!filter.type.includes(p.type)) return false
    } else {
      if (p.type !== filter.type) return false
    }
  }
  if (filter.project_id && Number(p.project_id) !== Number(filter.project_id)) return false
  return true
}
